import { select } from '@ps/web-core-store';
import { ActiveGameType } from '@ps/web-poker-types';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import useOpenActiveGame from '../useOpenActiveGame';

const useTournamentUnregister = (id?: number): (() => void) => {
  const { focusActiveGame } = useOpenActiveGame();
  const isEmbedded = useSelector(select.device.isEmbedded);

  return useCallback((): void => {
    if (!id) return;

    if (isEmbedded) {
      return window.starsweb?.app?.execute?.(`tourn-unreg/${id}`);
    }

    focusActiveGame({
      id,
      type: ActiveGameType.Tourney
    });
  }, [id, isEmbedded, focusActiveGame]);
};

export default useTournamentUnregister;
